import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { interval, timer } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IBanner } from '../../interfaces/i-banner';
import { AppService } from '../../services/app.service';
import { WebappService } from '../../services/webapp.service';
import { BANNERS } from '../../utils/banners';

@Component({
  selector: 'mobo-banner',
  templateUrl: './banner.component.html',
  styles: [],
})
export class BannerComponent implements OnInit, OnDestroy {
  public startIndex = 2;
  public banners: IBanner[] = BANNERS.map((x, id) => {
    let priority = id === this.startIndex;
    return { ...x, id, priority } as IBanner;
  });
  public bannersNavegationRef: IBanner[] = [
    ...this.banners.slice(this.startIndex), // Coloca o banner inicial no primeiro bullet
    ...this.banners.slice(0, this.startIndex),
  ];
  public currentBanner = this.banners[this.startIndex];
  public interval = interval(10000);
  public subs: any;
  public direction = 'l';
  public animate = false;
  public removing = false;
  public skipNextInterval = false;
  public baseUrl = environment.baseUrl;

  isBrowser: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    public appService: AppService,
    public webappService: WebappService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.getBanners();
    if (this.isBrowser) {
      this.subs = this.interval.subscribe(() => {
        if (!this.skipNextInterval) {
          this.right();
        }
        this.skipNextInterval = false;
      });
    }
  }

  ngOnDestroy() {
    if (this.isBrowser) {
      this.subs?.unsubscribe();
    }
  }

  getBanners() {
    let bannersTemp = [...this.banners];
    this.webappService.events.subscribe((events) => {
      if (!events[0]) {
        return;
      }
      bannersTemp.splice(
        this.startIndex + 2, // Insere banner de evento fora da tela
        0,
        ...events.map((event) => {
          let banner: IBanner = {
            src: event.ImageLarge,
            alt: event.Title,
            priority: true,
          };
          if (event.CampaignEventId) {
            banner['link'] = ['evento', event.CampaignEventId];
          } else if (event.ExternalLink) {
            banner['external'] = event.ExternalLink;
          }
          return banner;
        })
      );
      this.banners = bannersTemp.map((x, id) => ({ ...x, id } as IBanner));
      this.bannersNavegationRef = [
        ...this.banners.slice(this.startIndex), // Coloca o banner inicial no primeiro bullet
        ...this.banners.slice(0, this.startIndex),
      ];
    });
  }

  left() {
    if (this.removing || !this.isBrowser) {
      return;
    }
    this.skipNextInterval = true;
    this.animate = true;
    this.direction = 'r';
    let copy = [...this.banners];
    copy.unshift(copy.pop() || this.currentBanner);
    this.banners = copy;
    this.currentBanner = this.banners[this.startIndex];
    this.removeAnimate();
  }

  right() {
    if (this.removing || !this.isBrowser) {
      return;
    }
    this.skipNextInterval = true;
    this.animate = true;
    this.direction = 'l';
    let copy = [...this.banners];
    copy.reverse();
    copy.unshift(copy.pop() || this.currentBanner);
    copy.reverse();
    this.banners = copy;
    this.currentBanner = this.banners[this.startIndex];
    this.removeAnimate();
  }

  moveWithoutAnimation() {
    let copy = [...this.banners];
    copy.unshift(copy.pop() || this.currentBanner);
    this.banners = copy;
    this.currentBanner = this.banners[this.startIndex];
  }

  removeAnimate() {
    if (this.removing || !this.isBrowser) {
      return;
    }
    this.removing = true;
    timer(1000).subscribe((x) => {
      this.animate = false;
      this.removing = false;
    });
  }

  isBannerActive(index: number) {
    return index === this.currentBanner.id;
  }

  goToBanner(id: number = 0) {
    this.skipNextInterval = true;
    while (id != this.currentBanner.id) {
      this.moveWithoutAnimation();
    }
  }
}
